import { useEffect, Fragment } from 'react';
import { AUTOSUGGEST_ALIAS, ALIAS, API_DOMAIN, CUR_NETWORK, LANGUAGE, COUNTRY } from '@constants/index';
import { empty } from '@utils/index';

interface IAutoSuggestProps {
  inputValue: string;
  serviceAlias: string;
  submitCallback: (clickKeyword: string) => void;
}

let autoSuggest: any = null;

const setAutoSuggest = (param: IAutoSuggestProps) => {
  const suggestAlias = AUTOSUGGEST_ALIAS[ALIAS.TOTAL];
  const suggetSelector = '#search-autosuggest';
  const { serviceAlias, submitCallback } = param || {};

  if (autoSuggest) {
    empty(suggetSelector);
    autoSuggest = null;
  }

  autoSuggest =
    window?.ncui?.autoSuggest &&
    new window.ncui.autoSuggest({
      apiUrl: `${API_DOMAIN[CUR_NETWORK]}/${serviceAlias}/search/v2/${suggestAlias}/suggest`,
      selector: suggetSelector,
      size: 5,
      useDelbtn: true,
      useRecent: false,
      cookieName: `search-${serviceAlias}-${suggestAlias}`,
      locale: `${LANGUAGE}-${COUNTRY}`,
      keywordParamName: 'keyword',
      placeholderStr: '통합검색',
      useCookie: true,
      submitCallback,
    });
};

const AutoSuggest = ({ inputValue, serviceAlias, submitCallback }: IAutoSuggestProps) => {
  useEffect(() => {
    setAutoSuggest({
      inputValue,
      serviceAlias,
      submitCallback,
    });
  }, []);

  useEffect(() => {
    autoSuggest?.value(inputValue);
  }, [inputValue]);

  return <Fragment />;
};

export default AutoSuggest;
